<app-upsell-card
  htmlTitle="Add Fiber for <br class='is-hidden-tablet'><strong>Faster Relief</strong>"
  question="We highly recommend including fiber in your prescription. Would you like to add it to your treatment plan?"
  [slug]="slug"
>
  <p class="mb-4">
    Most hemorrhoid flare-ups are caused by hard stools and straining—two things a daily fiber supplement can
    significantly improve. Adding fiber is one of the simplest, most effective steps you can take to feel better
    <span class="is-italic">faster</span>.
  </p>
  <p>Patients who add a high-quality fiber supplement often experience:</p>
  <ul class="mt-2 mb-4">
    <li><strong>Softer, smoother bowel movements</strong> that are easier to pass</li>
    <li><strong>Less irritation, burning, and bleeding</strong> during recovery</li>
    <li><strong>Noticeably faster symptom relief</strong> within days</li>
    <li><strong>Far fewer flare-ups</strong> in the weeks and months ahead</li>
  </ul>
  <p class="mb-4">
    If you're ready to make restroom visits more comfortable—and help your treatment work even better—<strong
      >add our recommended fiber supplement to your plan today. Your body will feel the difference.</strong
    >
  </p>
</app-upsell-card>
